var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isMobile
    ? _c("div", { attrs: { id: "login-change" } }, [
        _vm.isLoggedIn
          ? _c("div", { staticClass: "dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-toggle",
                  attrs: {
                    href: "#",
                    "data-testing": "register-select",
                    id: "accountMenuList",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                    "data-boundary": "window",
                    "aria-label": _vm.$translate(
                      "Ceres::Template.loginRegister"
                    ),
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-user d-sm-none",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "hidden-xs-down" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.loginHello", {
                          username: _vm.username,
                        })
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "account-menu dropdown-menu dropdown-menu-right small",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "list-group",
                      attrs: { "aria-labelledby": "accountMenuList" },
                    },
                    [
                      _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                        _c("i", { staticClass: "fa fa-user" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginMyAccount")
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [{ name: "logout", rawName: "v-logout" }],
                          attrs: { href: "#" },
                        },
                        [
                          _c("i", { staticClass: "fa fa-sign-out" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.loginLogout")
                              )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isLoggedIn
          ? _c("div", { staticClass: "dropdown" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    "data-testing": "login-select",
                    id: "accountMenuList",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                    "data-boundary": "window",
                    "aria-label": _vm.$translate("Ceres::Template.login"),
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-user",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "account-menu dropdown-menu dropdown-menu-right small",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "list-group",
                      attrs: { "aria-labelledby": "accountMenuList" },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.isLogin ? "javascript:void(0)" : "#login",
                            "data-toggle": _vm.isLogin ? false : "modal",
                          },
                          on: {
                            click: function ($event) {
                              _vm.createLoginModal()
                              _vm.unmarkInputFields()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-user",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "hidden-xs-down" }, [
                            _vm._v(
                              _vm._s(_vm.$translate("Ceres::Template.login"))
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showRegistration
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.isRegister
                                  ? "javascript:void(0)"
                                  : "#registration",
                                "data-toggle": _vm.isRegister ? false : "modal",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.createRegisterModal()
                                  _vm.unmarkInputFields()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-user-plus",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "hidden-xs-down" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.loginRegister"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ])
    : _c(
        "div",
        { attrs: { id: "login-change" } },
        [
          _vm.isLoggedIn
            ? [
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "login-btn",
                    attrs: { href: "#" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "register-btn",
                    attrs: { href: _vm.$ceres.urls.myAccount },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoggedIn
            ? [
                _c(
                  "a",
                  {
                    staticClass: "login-btn",
                    attrs: {
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                    },
                    on: {
                      click: function ($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$translate("Ceres::Template.login")) +
                        "\n\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.showRegistration
                  ? _c(
                      "a",
                      {
                        staticClass: "register-btn",
                        attrs: {
                          href: _vm.isRegister
                            ? "javascript:void(0)"
                            : "#registration",
                          "data-toggle": _vm.isRegister ? false : "modal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.createRegisterModal()
                            _vm.unmarkInputFields()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginRegister")
                            ) +
                            "\n\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }